export const GET_PAGES = 'GET_PAGES';
export const GET_PAGE = 'GET_PAGEs';
export const SET_PAGES = 'SET_PAGES';
export const CREATE_PAGE = 'CREATE_PAGE';
export const EDIT_PAGE = 'EDIT_PAGE';
export const DELETE_PAGE = 'DELETE_PAGE';
